import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

var _ActiveMarker;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useEffect, useMemo, useState } from 'react';
import GoogleMapReact from 'google-map-react';
import { get, invoke } from 'lodash-es';
import ActiveMarker from './ActiveMarker';
var DEFAULT_MAP_POSITION = {
  CENTER: {
    lat: -6.2008406,
    lng: 106.7987143
  },
  ZOOM: 17
};
var DEFAULT_CONTAINER_STYLE = {
  height: '50vw',
  maxHeight: 'calc(100vh - 2rem)'
};

var MapsInput = function MapsInput(_ref) {
  var _ref$containerStyle = _ref.containerStyle,
      containerStyle = _ref$containerStyle === void 0 ? {} : _ref$containerStyle,
      value = _ref.value,
      _ref$readOnly = _ref.readOnly,
      readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function (e) {
    return e;
  } : _ref$onChange,
      _ref$onGoogleApiLoade = _ref.onGoogleApiLoaded,
      _onGoogleApiLoaded = _ref$onGoogleApiLoade === void 0 ? function (e) {
    return e;
  } : _ref$onGoogleApiLoade,
      _ref$gmapsApiKey = _ref.gmapsApiKey,
      gmapsApiKey = _ref$gmapsApiKey === void 0 ? process.env.REACT_APP_GMAPS_API_KEY : _ref$gmapsApiKey;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      map = _useState2[0],
      setMap = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      maps = _useState4[0],
      setMaps = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      geocoder = _useState6[0],
      setGeocoder = _useState6[1];

  var _useState7 = useState(null),
      _useState8 = _slicedToArray(_useState7, 2),
      localActiveMarker = _useState8[0],
      setLocalActiveMarker = _useState8[1];

  var activeMarker = useMemo(function () {
    return get(value, 'lat') && get(value, 'lng') ? value : localActiveMarker;
  }, [value, localActiveMarker]);

  var handleMarkerChange = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
      var lat, lng;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              lat = _ref2.lat, lng = _ref2.lng;
              setLocalActiveMarker({
                visible: true,
                lat: lat,
                lng: lng
              });
              geocoder.geocode({
                location: {
                  lat: lat,
                  lng: lng
                }
              }, function (response, status) {
                if (status === 'OK') {
                  onChange({
                    lat: invoke(response, '[0].geometry.location.lat') || DEFAULT_MAP_POSITION.CENTER.lat,
                    lng: invoke(response, '[0].geometry.location.lng') || DEFAULT_MAP_POSITION.CENTER.lng
                  }, get(response, '[0]'), response);
                }
              });

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleMarkerChange(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  var mapDetailsRootElement = useMemo(function () {
    return document.createElement('div');
  }, []);
  useEffect(function () {
    if (map && maps) {
      map.controls[maps.ControlPosition.TOP_LEFT].push(mapDetailsRootElement);
    }

    return function () {
      if (map && maps) {
        map.controls[maps.ControlPosition.TOP_LEFT].clear();
      }
    };
  }, [map, mapDetailsRootElement, maps]);
  useEffect(function () {
    if (activeMarker && map) {
      map.panTo({
        lat: parseFloat(activeMarker.lat),
        lng: parseFloat(activeMarker.lng)
      });
      map.setZoom(17);
    }
  }, [activeMarker, map]);
  return /*#__PURE__*/React.createElement("div", {
    style: _objectSpread(_objectSpread({}, DEFAULT_CONTAINER_STYLE), containerStyle)
  }, /*#__PURE__*/React.createElement(GoogleMapReact, {
    bootstrapURLKeys: {
      key: gmapsApiKey,
      libraries: 'places'
    },
    defaultCenter: DEFAULT_MAP_POSITION.CENTER,
    defaultZoom: DEFAULT_MAP_POSITION.ZOOM,
    onClick: readOnly ? undefined : handleMarkerChange,
    onGoogleApiLoaded: function onGoogleApiLoaded(google) {
      setMap(google.map);
      setMaps(google.maps);
      setGeocoder(new google.maps.Geocoder());

      _onGoogleApiLoaded(google);
    },
    options: function options(mapsOptions) {
      return {
        zoomControlOptions: {
          position: mapsOptions.ControlPosition.RIGHT_BOTTOM,
          style: mapsOptions.ZoomControlStyle.SMALL
        },
        mapTypeControlOptions: {
          position: mapsOptions.ControlPosition.LEFT_BOTTOM
        },
        mapTypeControl: true,
        controlSize: 27
      };
    },
    yesIWantToUseGoogleMapApiInternals: true
  }, activeMarker && (_ActiveMarker || (_ActiveMarker = /*#__PURE__*/React.createElement(ActiveMarker, null)))));
};

export default MapsInput;